/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
var win=typeof window!=="undefined"?window:undefined;var doc=typeof document!=="undefined"?document:undefined;export{doc as d,win as w};